import { byId, qsAll } from "./dom";

export interface OverlayController {
  open(): void;
  close(): void;
  isOpen(): boolean;
}

/** Wires a `.sheet-overlay` element (see index.html / style.css) so it can
 *  be opened/closed programmatically, closed by its backdrop, its
 *  `[data-sheet-close]` buttons, or the Escape key. */
export function createOverlay(overlayId: string): OverlayController {
  const overlay = byId(overlayId);
  const panel = overlay.querySelector<HTMLElement>(".sheet-panel");

  function close(): void {
    overlay.hidden = true;
    overlay.classList.remove("is-open");
    document.body.classList.remove("sheet-lock");
  }

  function open(): void {
    overlay.hidden = false;
    // Next frame, so the CSS transition on is-open actually runs.
    requestAnimationFrame(() => overlay.classList.add("is-open"));
    document.body.classList.add("sheet-lock");
  }

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) close();
  });

  qsAll("[data-sheet-close]", overlay).forEach((btn) => {
    btn.addEventListener("click", close);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !overlay.hidden) close();
  });

  void panel;

  return {
    open,
    close,
    isOpen: () => !overlay.hidden,
  };
}
